import React from "react";
import EditingGrid from "./editing-grid";
import PropTypes from "prop-types";
import TextInput from "./text-input";
import { useDispatch, useSelector } from "react-redux";
import {
  selectOptionFromKey,
  updateSelectedOptionValueByKey,
  updateOtherOption,
} from "../../customisation-slice";
import EditingDisabled from "./editing-disabled";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  editingOptions: PropTypes.instanceOf(Object).isRequired,
  selectedOption: PropTypes.instanceOf(Object),
  showInitialsColors: PropTypes.bool.isRequired,
};

const InitialsView = ({
  editingOptions,
  selectedOption,
  showInitialsColors,
}) => {
  const dispatch = useDispatch();
  const stampState = useSelector((state) =>
    selectOptionFromKey(state, "stamp")
  );

  const defaultEditingGridClasses = ["overflow-y-auto", "md:block"];

  conditionallyAddStyles(
    !showInitialsColors,
    defaultEditingGridClasses,
    "hidden"
  );

  return (
    <>
      {stampState.selected === "none" ? (
        <div className="flex-grow flex flex-col overflow-y-hidden">
          <TextInput
            title="Add your initials"
            instruction="Max. 2 alphanumeric characters (letters A–Z, numbers 0–9)"
            value={selectedOption.text}
            onChange={(event) =>
              dispatch(
                updateSelectedOptionValueByKey({
                  valueKey: "text",
                  value: event.target.value.replace(/[^a-z0-9]/gi, ""),
                })
              )
            }
            maxLength={2}
            show={!showInitialsColors}
          />
          <div className="hidden md:block heading-4 p-6 border-b border-light-grey">
            Text Colour
          </div>
          <div className={defaultEditingGridClasses.join(" ")}>
            <EditingGrid
              editingOptions={editingOptions}
              selectedOption={selectedOption.selected}
            />
          </div>
        </div>
      ) : (
        <EditingDisabled
          instruction="Initials are placed on the watch dial in the same position as a stamp. Please remove your stamp option to apply initials"
          buttonOnClick={() =>
            dispatch(updateOtherOption({ optionKey: "stamp", value: "none" }))
          }
          buttonText="Remove Stamp"
        />
      )}
    </>
  );
};

InitialsView.propTypes = propTypes;

export default InitialsView;
